import { IProduct, Product } from './product';

export interface IOtherProduct extends IProduct {
    initials: string;
    activePrice: number;
    inactivePrice: number;
}

export class OtherProduct extends Product implements IOtherProduct {
    initials = null;
    price = null;
    activePrice = null;
    inactivePrice = null;
}